import React 				from 'react';
import PropTypes 			from 'prop-types';
import BLComponent			from '../core/_BLComponent.jsx';

export default class NewsCard extends BLComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', noTrunc = false} = this.props;
		const {title, intro, link, date, replies} = this.props.data;
		const cardTitle = noTrunc ? title : (title.length > 43 ? title.slice(0, 43) + '...' : title);
		const cardIntro = noTrunc ? intro : (intro.length > 75 ? (intro.slice(0, 75) + '...') : intro);

		return (
			<article className={"card " + classes}>
				<a href={link} target="_blank" className="card__internal news-card">
					<p className="news-card__date">{blapp.format.formatDateTime(date)}</p>
					<h1 className="news-card__title">{cardTitle}</h1>
					{intro ? 
						<p className="news-card__intro">{cardIntro}</p>
					: null}
					{replies ? 
						<div className="news-card__replies">
							<i className="fas fa-reply l-margin-right--sm"/>
							{`${replies} ${replies == 1 ? 'reply' : 'replies'}`}
						</div>
					: 
						<div className="news-card__replies l-flex">
							<div className="btn btn--thick btn--small btn--white l-border">
								Read more
							</div>
						</div>
					}
				</a>
			</article>
		);
	}
}

NewsCard.propTypes = {
		classes: PropTypes.string
	, noTrunc: PropTypes.bool
	,	data: PropTypes.shape({
				date: PropTypes.string.isRequired
			,	title: PropTypes.string.isRequired
			,	intro: PropTypes.string.isRequired
			, link: PropTypes.string.isRequired
			, replies: PropTypes.number.isRequired
		}).isRequired
}